module.exports = __webpack_public_path__ + "img/b.47086290.jpg";